import { render, staticRenderFns } from "./confirmar_desconocido.vue?vue&type=template&id=3b871c54&scoped=true"
import script from "./confirmar_desconocido.vue?vue&type=script&lang=js"
export * from "./confirmar_desconocido.vue?vue&type=script&lang=js"
import style0 from "./confirmar_desconocido.vue?vue&type=style&index=0&id=3b871c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b871c54",
  null
  
)

export default component.exports